<template>
  <div>
    <v-divider v-if="hasConfirmation" class="my-8" />

    <v-row>
      <v-col v-if="hasConfirmation" cols="12" md="6">
        <v-row>
          <v-col>
            <h2>
              {{ $t('appointment.confirmAppointment.title') }}
            </h2>
          </v-col>
        </v-row>
        <v-row v-if="confirmationAnswered">
          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.confirmAppointment') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.confirmed != null
                ? appointment.confirmation.confirmed
                  ? $t('appointment.confirmAppointment.form.yes')
                  : $t('appointment.confirmAppointment.form.no')
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.attendingToAppointment') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.attending_to_appointment != null
                ? appointment.confirmation.attending_to_appointment
                  ? $t('appointment.confirmAppointment.form.yes')
                  : $t('appointment.confirmAppointment.form.no')
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.keysNeedsAuthorization') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.keys_needs_authorization != null
                ? appointment.confirmation.keys_needs_authorization
                  ? $t('appointment.confirmAppointment.form.yes')
                  : $t('appointment.confirmAppointment.form.no')
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.observation') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.comment != null
                ? appointment.confirmation.comment
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.sentAt') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.sent_at != null
                ? formatDate(appointment.confirmation.sent_at)
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.answeredAt') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.answered_at != null
                ? formatDate(appointment.confirmation.answered_at)
                : '---' }}
            </span>
          </v-col>

          <v-col sm="6">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.acceptedDate') }}
            </h6>
            <span class="body-2">
              {{ appointment.confirmation.accepted_date != null
                ? formatDate(appointment.confirmation.accepted_date)
                : '---' }}
            </span>
          </v-col>

          <v-col sm="12">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.confirmAppointment.form.signature') }}
            </h6>

            <div v-if="signatureUrl" class="d-flex align-center mt-2">
              <v-img
                :src="signatureUrl"
                max-width="350"
                min-height="150"
                class="confirmation-signature mr-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="primary" />
                  </v-row>
                </template>
              </v-img>
              <v-btn @click="openSignatureInNewTab" icon color="primary">
                <v-icon>
                  mdi-open-in-new
                </v-icon>
              </v-btn>
            </div>
            <span v-else class="body-2">
              ---
            </span>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col sm="6">
            <span class="body-2 grey--text">
              {{ $t('appointment.confirmAppointment.messages.notAnsweredYet') }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mailto,
  whatsApp,
  catalogPhone,
  catalogDate,
} from '@/util/catalog'
import { formatDocument } from '@/util/document'
import { getConfirmationSignatureUrl } from '@/services/appointment/appointmentService'
import appointment from '../../../store/modules/appointment';

export default {
  name: 'AppointmentHostAndVisitor',

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  watch: {
    appointment() {
      if (this.appointment?.confirmation?.signature) {
        this.getConfirmationSignatureUrl()
      }
    }
  },

  computed: {
    hasConfirmation() {
      return this.appointment?.confirmation
    },

    confirmationAnswered() {
      return this.appointment?.confirmation?.answered
    },

    showFeedbackButton() {
      return this.appointment?.real_estate_feedback === null
    },

    host() {
      return this.appointment?.host
    },

    hostPhone() {
      return catalogPhone(this.host?.phone)
    },

    hostRG() {
      return this.host?.rg ?? '---'
    },

    hostCPF() {
      return this.host?.cpf ?? null
    },

    visitorPhone() {
      return catalogPhone(this.appointment?.visitor_phone)
    },
  },

  methods: {
    async getConfirmationSignatureUrl() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      let requestRole = 'OPEN'
      if (userRoles?.includes('ROLE_ADMIN')) {
        requestRole = 'ADMIN'
      }
      if (userRoles?.includes('ROLE_REAL_ESTATE')) {
        requestRole = 'WEB'
      }

      await getConfirmationSignatureUrl(requestRole, this.appointment?.id)
        .then(({ data }) => this.signatureUrl = data.url)
        .catch(({ data }) => this.$store.dispatch('showErrorMessage', data.message))
    },

    async openSignatureInNewTab() {
      if (this.signatureUrl) {
        window.open(this.signatureUrl, '_blank')
      }
    }
  },

  data() {
    return {
      mailto,
      whatsApp,
      formatDocument,
      formatDate: catalogDate,
      signatureUrl: null,
    }
  },

  mounted() {

    if (this.appointment?.confirmation?.signature) {
      this.getConfirmationSignatureUrl()
    }
  }
}
</script>

<style scoped>
.confirmation-signature {
  border: 1px solid #009DD9;
  border-radius: 5px;
}
</style>
